import { UserDelegationTargetTypeEnum } from '@zaoblako/shared/modules/security/enums/user-delegation-target-type.enum';
import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import type { EnumI18nInterface } from '@zaoblako/shared/common/interfaces/enum.i18n.interface';

/** Localized human-readable string representations of {@link UserDelegationTargetTypeEnum} enumeration values */
export const UserDelegationTargetTypeEnumI18n: EnumI18nInterface<UserDelegationTargetTypeEnum> = {
  [I18nLocalesEnum.RU_RU]: {
    [UserDelegationTargetTypeEnum.ACTIVE_BRS_TASKS_APPROVER]: 'Согласователь',
    [UserDelegationTargetTypeEnum.ACTIVE_BRS_TASKS_AUDITOR]: 'Аудитор',
  },
  [I18nLocalesEnum.EN_US]: {
    [UserDelegationTargetTypeEnum.ACTIVE_BRS_TASKS_APPROVER]: 'Approver',
    [UserDelegationTargetTypeEnum.ACTIVE_BRS_TASKS_AUDITOR]: 'Auditor',
  },
};
